var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "chart-container" },
    [
      _vm.title
        ? _c("div", { ref: "titleArea", staticClass: "title-container" }, [
            _c("h4", { staticClass: "title", style: { ..._vm.titleStyle } }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _c(
              "div",
              { staticClass: "flex-align-center" },
              [
                _vm.showAvgBtn
                  ? _c(
                      "a-button",
                      {
                        staticClass: "avg-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.setAvgLine },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.showAvgLineStatus
                                ? "关闭平均值"
                                : "显示平均值"
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._t("titleExtra"),
              ],
              2
            ),
          ])
        : _vm._e(),
      _c("div", {
        ref: "chart",
        staticClass: "chart",
        style: { width: "100%", height: _vm.height, ..._vm.chartStyle },
        on: { click: _vm.chartClick },
      }),
      _c("Transition", { attrs: { name: "avg" } }, [
        _vm.showAvgLineStatus
          ? _c(
              "div",
              { staticClass: "avg-sum-container" },
              _vm._l(_vm.avgOrSumArr, function (item, index, key) {
                return _c("div", { key: index }, [
                  _c(
                    "div",
                    {
                      staticClass: "title-2",
                      staticStyle: { "margin-top": "5px" },
                    },
                    [_vm._v(_vm._s(item.month))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "flex-align-center",
                      staticStyle: {
                        "flex-wrap": "wrap",
                        "margin-left": "20px",
                      },
                    },
                    [
                      _vm._l(item, function (value, key) {
                        return key != "month"
                          ? [
                              _c("span", { staticClass: "key-item" }, [
                                _c("span", [_vm._v(_vm._s(key) + "：")]),
                                _c("span", [_vm._v(_vm._s(value))]),
                              ]),
                            ]
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ])
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._t("bottomExpandArea", function () {
        return [
          _vm.showBottomExpandArea && _vm.markdownText
            ? _c(
                "div",
                { staticClass: "bottom-expand-area" },
                [
                  _vm.markdownText
                    ? _c("MarkdownIt", { attrs: { content: _vm.markdownText } })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
      _vm.markList && _vm.markList.length > 0
        ? _c(
            "div",
            _vm._l(_vm.markList, function (item, index) {
              return _c("img", {
                key: index,
                staticClass: "img-appear",
                style: {
                  position: "absolute",
                  left: item.position[0] - 1 + "px",
                  top: item.position[1] - 4 + "px",
                },
                attrs: { src: item.image, alt: "" },
                on: { click: (e) => _vm.lineMarkerClick(e, item) },
              })
            }),
            0
          )
        : _vm._e(),
      _vm.tipStatus
        ? _c("div", [
            _c(
              "div",
              {
                ref: "tipModal",
                staticClass: "tip-modal animate__animated animate__bounceIn",
                style: _vm.tipStyle,
              },
              [
                _vm._t(
                  "guideTipModal",
                  function () {
                    return [
                      _vm.guideTipList.length
                        ? _vm._l(_vm.guideTipList, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticStyle: {
                                  width: "100%",
                                  "margin-bottom": "10px",
                                },
                              },
                              [
                                _c("div", { staticClass: "tip-head" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "tip-title",
                                      class:
                                        item.type == "warn"
                                          ? "warn-title"
                                          : item.type == "intervene"
                                          ? "intervene-title"
                                          : "",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.title) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _c("span", { staticClass: "tip-time" }, [
                                    _vm._v(_vm._s(item.time)),
                                  ]),
                                ]),
                                _c("div", { staticClass: "tip-desc" }, [
                                  _vm._v(_vm._s(item.desc)),
                                ]),
                              ]
                            )
                          })
                        : [
                            _c("EmptyData", {
                              attrs: {
                                styleObj: { width: "100%", height: "100%" },
                              },
                            }),
                          ],
                    ]
                  },
                  { record: _vm.guideTipList }
                ),
              ],
              2
            ),
            _c(
              "div",
              {
                staticClass: "tip-mask",
                on: { click: () => (_vm.tipStatus = false) },
              },
              [_vm._v("关闭")]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }